import { StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { Fragment } from 'react';
import { renderStructuredContent } from '../rendererContext';
import type { RendererProps } from '../types';

type DocumentProps = StructuredContentDocument<{
  children: StructuredContentDocument;
  rendererProps?: RendererProps;
}>;

export function Document({ props: { children, rendererProps } }: DocumentProps) {
  return (
    <>
      {[children].flat().map((child, idx) => {
        if (typeof child === 'string') {
          return <Fragment key={idx}>{child}</Fragment>;
        }
        if (child) {
          return <Fragment key={idx}>{renderStructuredContent(child, rendererProps)}</Fragment>;
        }
      })}
    </>
  );
}
